module.exports = vendors_ru_99b430603c7880df01b7;